export const isImage = (file) => file.type.split("/")[0] === "image";

const convertBytesToMbsOrKbs = (filesize) => {
  let size = "";
  // I know, not technically correct...
  if (filesize >= 1000000) {
    size = `${filesize / 1000000}MB`;
  } else if (filesize >= 1000) {
    size = `${filesize / 1000}KB`;
  } else {
    size = `${filesize}B`;
  }
  return size;
};

const createFileFromUrl = async (url) => {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = { type: data.type };
  const filename = url.replace(/\?.+/, "").split("/").pop();
  return new File([data], filename, metadata);
};

const readFile = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event?.target?.result);
    };
    reader.onerror = (event) => {
      reader.abort();
      reject(event);
    };
    reader.readAsDataURL(file);
  });

export { convertBytesToMbsOrKbs, createFileFromUrl, readFile };
